import React, { useMemo } from "react";
import { Check, X } from "lucide-react";

const PASSWORD_REQUIREMENTS = [
  { regex: /.{8,}/, text: "حداقل ۸ کاراکتر" },
  { regex: /[0-9]/, text: "حداقل ۱ عدد" },
  { regex: /[a-z]/, text: "حداقل ۱ حرف کوچک" },
  { regex: /[A-Z]/, text: "حداقل ۱ حرف بزرگ" },
  { regex: /[!-/:-@[-`{-~]/, text: "حداقل ۱ کاراکتر ویژه (مانند !@#$%^&*)" },
];

// const STRENGTH_TEXTS = {
//   0: "رمز عبور را وارد کنید",
//   1: "رمز عبور ضعیف",
//   2: "رمز عبور متوسط!",
//   3: "رمز عبور قوی!!",
//   4: "رمز عبور بسیار قوی!!!",
// };

const STRENGTH_COLORS = [
  "bg-green-200",
  "bg-green-300",
  "bg-green-400",
  "bg-green-500",
  "bg-green-600",
];

export default function PassStrength({
  password = "",
  id = "password-strength",
  showValidationErrors = false,
}) {
  const strength = useMemo(() => {
    const requirements = PASSWORD_REQUIREMENTS.map((requirement) => ({
      met: requirement.regex.test(password),
      text: requirement.text,
    }));

    return {
      score: requirements.filter((requirement) => requirement.met).length,
      requirements,
    };
  }, [password]);

  return (
    <div className="w-full">
      <div className="flex gap-2 w-full justify-between mt-3">
        {STRENGTH_COLORS.map((color, index) => (
          <span
            key={color}
            className={`${
              strength.score > index ? color : "bg-zi-inputbg-dark"
            } p-1 rounded-full w-full`}
          />
        ))}
      </div>

      <p id={id} className="my-2 flex justify-between text-sm font-medium">
        <span className="text-zi-text-light dark:text-zi-text-dark">می‌بایست شامل:</span>
        {/* <span className="text-zi-text-light dark:text-zi-text-dark">{STRENGTH_TEXTS[Math.min(strength.score, 4)]}</span> */}
      </p>

      <ul className="grid grid-cols-2 gap-y-3.5 py-2.5" aria-label="Password requirements">
        {strength.requirements.map((requirement) => {
          const unmetColor = showValidationErrors
            ? "text-amber-400"
            : "text-zi-text-light/50 dark:text-zi-text-dark/50";

          return (
            <li key={requirement.text} className="flex items-center gap-1">
              {requirement.met ? (
                <Check size={16} className="text-emerald-500 shrink-0" />
              ) : (
                <X size={16} className={`shrink-0 ${unmetColor}`} />
              )}

              <span
                className={`text-xs relative whitespace-nowrap ${
                  requirement.met ? "text-emerald-600" : unmetColor
                }`}
              >
                {requirement.text}

                <span className="sr-only">
                  {requirement.met
                    ? " - Requirement met"
                    : " - Requirement not met"}
                </span>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
